






















# TODO: add this for HM story: https://www.growthbunker.dev/vuetimeline
module.exports =
  name: 'changelog'
  metaInfo:
    title: 'Обновления'
  data: ->
    loading: true
    updates: {}
  mounted: ->
    $.getJSON HM_API.api_url + 'changelog.json', (posts) =>
      @updates = _.map posts, (post, index) ->
        # likes: actions_summary with id == 2
        message = post.cooked
        message = message.replace /\[исправление\]/g, '<span class="tag is-danger">исправлено</span>'
        message = message.replace /\[новое\]/g,       '<span class="tag is-success">новое</span>'
        message = message.replace /\[улучшение\]/g,   '<span class="tag is-warning">улучшено</span>'
        message = message.replace /\/\/forum.hmbee/g,   'http://forum.hmbee'
        { date: hm_date.distanceInWordsToNow(post.created_at), message: message }
      @loading = false
